'use client';
import styled, { css } from 'styled-components';

export const StyledHealthScreeningFlowContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.background.base};
`;

export const ContentContainer = styled.div`
  max-width: 1088px;
  padding: ${({ theme }) => theme.spacing(0, 6, 14)};
  margin: 0 auto;

  &:first-of-type {
    margin-top: ${({ theme }) => theme.spacing(4)};

    @media ${({ theme }) => theme.tabletL} {
      margin-top: ${({ theme }) => theme.spacing(14)};
    }
  }

  ${({ flex }) =>
    flex &&
    css`
      @media ${({ theme }) => theme.mobileS} {
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        gap: ${({ theme }) => theme.spacing(4)};
      }

      @media ${({ theme }) => theme.tabletL} {
        flex-direction: row;
      }
    `}
`;
